<template>
  <main class="main" id="main">
    <div class="top_line">
      <div class="container">
        <h1>Доставка пирогов</h1>
      </div>
    </div>
    <section class="section s-seo">
      <div class="container">
        <div class="seo_box">
          <div class="bottom-wrapper">
            <div class="line"></div>
            <h2 style="margin-top:2%;">Пироги</h2>
            <p>Закажите традиционные русские, осетинские, грузинские и эксклюзивные пироги от шеф-поваров ресторанов нашего города с любой начинкой на Ваш вкус.</p>
            <p>На нашем сайте вы найдете как традиционные пироги с мясом, творогом, луком и зеленью так и  пироги с фруктами.</p>
            <p><br/><center><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/global/articles/pie1.jpg" alt="Доставка пирогов" width="700" /></center></p>
            <h2 style="margin-top:2%;">Блинчики</h2>
            <p>Вкуснейшие блинчики со сладкими и сытными начинками. Забудьте о полуфабрикатах. Некогда готовить? Хотите действительно насладиться вкусной едой? Заказывайте все что душе угодно на <router-link to="/">хочу-поесть.рф</router-link></p>
            <h2 style="margin-top:2%;">Пельмени, вареники</h2>
            <p>Вареники с мясом, картошкой и зеленью, творогом, ягодами. Вкуснейшие пельмени и манты.</p>
            <p>Заходите, выбирайте и заказывайте на  <router-link to="/">хочу-поесть.рф</router-link> и помните, что за каждый заказ Вы получаете реальный cash-back который потом можно потратить на следующие заказы.</p>
            <router-link :to="'/product/5'" tag="div">
              <button class="menu_item_btn seo">ХОЧУ ПОЕСТЬ!</button>
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'pie'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/articles/pie.vue